export const CheckQuestion = ({ children }) => {
    return (
        <>
            {children}
        </>
    )
}
